




















import Vue, { PropType } from 'vue';
import { PeerGroupMembership } from '@/models/orgStructure';
import { MemberRole } from '@/models';

import PeerGroupCard from '@/components/PeerGroupCard.vue';
import PersistableItem from '@/components/PersistableItem.vue';
import PeerGroupRoleSelectorPills from '@/components/PeerGroupRoleSelectorPills.vue';

export default Vue.extend({
  components: {
    PeerGroupCard,
    PersistableItem,
    PeerGroupRoleSelectorPills
  },

  props: {
    membership: Object as PropType<PeerGroupMembership>,
    status: Number, // Well, an enum
    showRoleSelector: {
      type: Boolean,
      default: true
    },
    pillsBelow: {
      type: Boolean,
      default: false
    },
    slotInline: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      role: this.membership.role
    };
  },

  computed: {
    isDirty(): boolean {
      return this.role !== this.membership.role;
    },
    dirtyMembership(): PeerGroupMembership {
      return {
        ...this.membership,
        role: this.role
      };
    },
    topLevelClasses(): string[] {
      return this.pillsBelow
        ? ['d-flex', 'flex-column']
        : [
            'd-flex',
            'flex-grow-1',
            'justify-space-between',
            'flex-wrap',
            'flex-sm-nowrap'
          ];
    },
    controlsClasses(): string[] {
      const alignmentClasses = this.slotInline
        ? ['d-flex', 'align-center', 'justify-center', 'mx-2']
        : ['d-flex', 'flex-column', 'align-center', 'justify-center', 'mx-2'];

      const verticalMargin = this.pillsBelow ? 'my-3' : 'my-2';

      return [...alignmentClasses, verticalMargin];
    }
  },

  methods: {
    handleRoleChange(role: MemberRole) {
      this.role = role;
    }
  }
});
